import { render, staticRenderFns } from "./AmazeCard.vue?vue&type=template&id=b3ac4a5c&scoped=true"
import script from "./AmazeCard.vue?vue&type=script&lang=js"
export * from "./AmazeCard.vue?vue&type=script&lang=js"
import style0 from "./AmazeCard.vue?vue&type=style&index=0&id=b3ac4a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ac4a5c",
  null
  
)

export default component.exports